<template>
    <div class="rich-text-container">
        <ckeditor
            v-model="editorData"
            :config="editorConfig"
            @update:modelValue="handleInput"
        ></ckeditor>
    </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
    context: Object,
});

function handleInput(modelData) {
    props.context.node.input(modelData);
}

const editorData = ref(props.context.value || "");
// CKEDITOR.replace("editor1");
const editorConfig = {
    filebrowserBrowseUrl: "/media/filemanager/index.html",
    // filebrowserUploadUrl:
    //     "/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Files",
    toolbarGroups: [
        // {
        // 	name: 'clipboard',
        // 	groups: ['clipboard', 'undo']
        // },
        {
            name: "basicstyles",
            groups: ["basicstyles", "cleanup"],
        },
        {
            name: "paragraph",
            groups: [
                "list",
                "indent",
                "blocks",
                "align",
                "bidi",
                // 'filemanager',
            ],
        },
        {
            name: "styles",
        },
        {
            name: "filemanager",
        },

        {
            name: "links",
        },
        {
            name: "insert",
        },
        {
            name: "forms",
        },

        {
            name: "editing",
            groups: ["find", "selection", "spellchecker"],
        },
        {
            name: "document",
            groups: ["mode", "document", "doctools"],
        },
        {
            name: "tools",
        },
        {
            name: "others",
        },
        // '/',

        // {
        // 	name: 'colors'
        // },
        // { name: 'about' }
    ],
};
</script>
<style lang="scss">
.rich-text-container {
    min-height: 300px;
    margin-bottom: 1.5rem;

    textarea {
        display: none;
    }
}
</style>
